import { Injectable } from '@angular/core';
import {
  AbstractControl,
  AbstractControlOptions,
  UntypedFormBuilder,
  UntypedFormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { PrFormService } from '@app/components/pr-form/pr-form.service';
import { EstateDao } from '@app/dao/estate/estate.dao';
import { ExpenseDao } from '@app/dao/expense/expense.dao';
import { UtilsService } from '@app/providers/utils/utils.service';
import { NotificationsService } from '@app/components/notification/NotificationsService';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EaFeesFormService {
  generateSubject: Subject<UntypedFormGroup> = new Subject();

  constructor(
    protected estateDao: EstateDao,
    protected formBuilder: UntypedFormBuilder,
    protected utilsService: UtilsService,
    protected prFormService: PrFormService,
    protected notificationsService: NotificationsService,
  ) {}

  public generate(entity: any) {
    let options: AbstractControlOptions = {};

    let fees: UntypedFormGroup[] = [];
    if (entity.expenses)
      for (let fee of entity.expenses)
        fees.push(
          this.formBuilder.group({
            id: [fee ? fee.id : null],
            isCurrent: [
              fee && fee.endDate != null && fee.endDate != undefined
                ? false
                : true,
              this.RequiredIfValueIs('endDate'),
            ],
            frequency: [fee ? fee.frequency : null, Validators.required],
            amount: [fee ? fee.amount : null, Validators.required],
            startDate: [fee ? fee.startDate : null, Validators.required],
            endDate: [fee ? fee.endDate : null],
            type: [fee ? fee.type : null, Validators.required],
          }),
        );

    let group = this.formBuilder.group({
      fees: this.formBuilder.array(fees, Validators.nullValidator),
    });

    this.generateSubject.next(group);

    return group;
  }

  public extract(form) {
    let dto: any = {
      id: this.utilsService.emptyIsNull(form.value.id),
      isCurrent: this.utilsService.emptyIsNull(form.value.isCurrent),
      frequency: this.utilsService.emptyIsNull(form.value.frequency),
      amount: this.utilsService.emptyIsNull(form.value.amount),
      startDate: this.utilsService.emptyIsNull(form.value.startDate),
      endDate: this.utilsService.emptyIsNull(form.value.endDate),
      type: this.utilsService.emptyIsNull(form.value.type),
    };
    return dto;
  }

  public addFees(entity, form) {
    let fee = {};
    if (!entity.fees) entity.fees = [];
    entity.fees.push(fee);
    form.fees.push(
      this.formBuilder.group({
        id: '',
        isCurrent: [true, this.RequiredIfValueIs('endDate')],
        frequency: [null, Validators.required],
        amount: [null, Validators.required],
        startDate: [null, Validators.required],
        endDate: [null],
        type: [null, Validators.required],
      }),
    );
  }

  public removeFee(index, fees, userId, estateTypeUrl, estateId) {
    let fee = fees.value[index];
    if (fee.id) {
      fee.accountId = userId;
      this.prFormService.loading();
      this.estateDao
        .deleteRealestateExpense(userId, estateTypeUrl, estateId, fee.id)
        .subscribe(
          success => {
            this.prFormService.loaded();
            fees.removeAt(index);
          },
          errors => {
            console.error(errors);
            this.prFormService.loaded();
          },
        );
    } else fees.removeAt(index);
  }

  RequiredIfValueIs(
    target: string,
    disableInput: boolean = false,
    predicate: any | boolean = true,
  ): ValidatorFn {
    return (ctrl: AbstractControl): ValidationErrors => {
      if (ctrl.parent && ctrl.value && ctrl.value === predicate) {
        ctrl.parent.get(target).clearValidators();
        ctrl.parent.get(target).updateValueAndValidity();
        if (disableInput) ctrl.parent.get(target).disable();
      } else if (
        (ctrl.value != null ||
          (ctrl.value != undefined && ctrl.value != predicate)) &&
        ctrl.parent
      ) {
        ctrl.parent.get(target).setValidators(Validators.required);
        ctrl.parent.get(target).updateValueAndValidity();
        if (disableInput) ctrl.parent.get(target).enable();
      }
      return null;
    };
  }
}
